// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1xopY","upload":"Small_upload__1AzE5","imageWrap":"Small_imageWrap__3xeSf","removeBtn":"Small_removeBtn__K5_WD"};